import { Stack } from '@chakra-ui/react'
import { FIRST_PAGE, PaginationGroupItems } from './PaginationGroupItems'
import { Button, IconArrow } from '@gazin/ecommerce-ui'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { makePageUrl } from 'src/util/url'

interface PaginationProps {
  pagination: {
    firstPage: number
    currentPage: number
    nextPage: number
    lastPage: number
    prevPage: number
  }
}

export const PaginationComponent = ({ pagination }: PaginationProps) => {
  const { currentPage, nextPage, lastPage } = pagination
  const route = useRouter()

  const paginationGroupItemsProps = {
    currentPage,
    lastPage,
    nextPage,
  }

  return (
    <Stack
      direction={['column', 'row']}
      spacing="2"
      align="center"
      mt="8"
      justify="space-between"
    >
      <Link href={`${makePageUrl(pagination.prevPage, route)}`}>
        <Button
          size="sm"
          fontSize="sm"
          width="28"
          bg="white"
          border="1px solid"
          borderColor="#DCDDE3"
          borderRadius=".1875rem"
          color="#646981"
          isDisabled={currentPage === FIRST_PAGE}
          leftIcon={
            <IconArrow color="primary.500" transform="rotate(180deg)" />
          }
        >
          Anterior
        </Button>
      </Link>

      <PaginationGroupItems {...paginationGroupItemsProps} />

      <Link href={`${makePageUrl(pagination.nextPage, route)}`}>
        <Button
          size="sm"
          fontSize="sm"
          width="28"
          bg="white"
          border="1px solid"
          borderColor="#DCDDE3"
          borderRadius=".1875rem"
          color="#646981"
          isDisabled={currentPage === lastPage}
          rightIcon={<IconArrow color="primary.500" />}
        >
          Próximo
        </Button>
      </Link>
    </Stack>
  )
}
